import customerInfo from './customerInfo';
import coInsuredInfo from './coInsuredInfo';
import customerAnimals from './customerAnimals';
import customerChildren from './customerChildren';


const reducers = {
    customerInfo,
    coInsuredInfo,
    customerAnimals,
    customerChildren
};

export default reducers;